<template>
  <div :class="status" class="status" ref="status">
    <i class="material-icons">{{ icons[status] }}</i>
    <span v-html="message"></span>
  </div>
</template>

<script>
export default {
  name: "StatusInfo",
  props: {
    status: {
      type: String,
      default: "info",
    },
    message: {
      type: String,
      default: "This is a notificaton",
    },
    maxWidth: {
      type: String,
      default: "100%",
    },
    disappear: {
      type: Boolean,
      default: true,
    },
    timeout: {
      type: Number,
      default: 4000,
    },
  },
  data() {
    return {
      iconName: "",
      icons: {
        info: "info_outline",
        error: "close",
        success: "done",
        warn: "warning",
      },

      currentHeight: 0,
    };
  },
  watch: {
    maxWidth(newWidth) {
      const status = this.$refs.status;

      status.style.maxWidth = newWidth;
      status.style.marginLeft = "auto";
      status.style.marginRight = "auto";
    },
  },
  mounted() {
    if (!this.disappear) return;

    const status = this.$refs.status;
    this.currentHeight = status.getBoundingClientRect().height;
    status.style.height = `${this.currentHeight}px`;

    setTimeout(() => this.hideStatus(), this.timeout);
  },
  methods: {
    hideStatus() {
      const status = this.$refs.status;

      status.classList.add("hidden");

      setTimeout(() => {
        status.style.display = "none";
        status.classList.remove("hidden");
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
// TODO update the framework so as to include options for outline
.status {
  display: block;
  padding: 1rem 0.75rem !important;
  border-radius: 3px;
  margin-bottom: 10px;
  overflow: hidden;
  display: flex;
  align-items: center;
  transition: all 0.25s linear;

  span {
    font-size: 14px;
  }

  i {
    font-size: 1.3rem;
    margin-right: 0.75rem;
  }

  &.error {
    border-color: $error !important;
    background-color: $error !important;
    color: white !important;
  }
  &.info {
    border-color: $info !important;
    background-color: $info !important;
    color: white !important;
  }
  &.warn {
    border-color: $warn !important;
    background-color: $warn !important;
    color: white !important;
  }
  &.success {
    border-color: $success !important;
    background-color: $success !important;
    color: white !important;
  }

  &.hidden {
    padding: 0;
    height: 0 !important;

    * {
      opacity: 0;
      transition: inherit;
    }
  }
}
</style>
